import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ReportingCard } from 'libs.react';
import { CompositeComponent } from './composite_component.component';
import { CompositeLayout } from './composite_layout.component';
import { ChartHeader } from '../report_chart/report_chart_header.component';
export const CompositeCard = ({ chart, chartQueryFilters, chartPresetFilters, setChartFilterModal, filterParams, studyId, isPublic, forceFresh = false, refreshNonce = 0, }) => {
    const lastRefreshed = useMemo(() => new Date().toISOString(), []);
    // For composite cards, we use the chart config directly since there's no actual chart data
    // at the root level - the real charts are the individual components
    const cardData = useMemo(() => {
        return chart;
    }, [chart]);
    // Create a Chart-like object for header compatibility
    const chartForHeader = useMemo(() => {
        if (!cardData) {
            return null;
        }
        return {
            id: cardData.id,
            title: cardData.title,
            type: 'composite', // Type assertion to Chart type
            cardInfo: cardData.cardInfo,
            // Add minimal required properties for Chart interface
            query: {},
            pivotConfig: {},
        };
    }, [cardData]);
    // No loading state needed for composite cards since we use the config directly
    // Error state - no card data
    if (!cardData) {
        return (_jsx(ReportingCard, { title: _jsx("div", { className: 'px-2', children: chart.title }), children: _jsx("div", { className: 'flex items-center justify-center size-full', children: _jsx("div", { className: 'text-red-600 text-center', children: _jsx("p", { children: "Error: Unable to load composite card configuration" }) }) }) }, chart.id));
    }
    // Invalid configuration
    if (!cardData.layout || !cardData.components || cardData.components.length === 0) {
        return (_jsx(ReportingCard, { title: _jsx("div", { className: 'px-2', children: chart.title }), children: _jsx("div", { className: 'flex items-center justify-center size-full', children: _jsx("div", { className: 'text-orange-600 text-center', children: _jsx("p", { children: "Warning: Composite card has no components configured" }) }) }) }, chart.id));
    }
    // Render individual components
    const componentElements = cardData.components.map((component) => (_jsx(CompositeComponent, { component: component, chartQueryFilters: chartQueryFilters, chartPresetFilters: chartPresetFilters, filterParams: filterParams, studyId: studyId, isPublic: isPublic, cardId: cardData.id, forceFresh: forceFresh, refreshNonce: refreshNonce }, component.id)));
    return (_jsx(ReportingCard, { title: chartForHeader ? (_jsx(ChartHeader, { chart: chartForHeader, lastRefreshed: lastRefreshed, chartQueryFilters: chartQueryFilters, chartPresetFilters: chartPresetFilters, setChartFilterModal: setChartFilterModal, isLoading: false })) : (_jsx("div", { className: 'px-2', children: cardData.title })), children: _jsx(CompositeLayout, { layout: cardData.layout, components: cardData.components, children: componentElements }) }, chart.id));
};
